// extracted by mini-css-extract-plugin
module.exports = {"textfield":"ExtendCoolingModal_textfield__10jz8","duration":"ExtendCoolingModal_duration__2faSZ","btnWrapper":"ExtendCoolingModal_btnWrapper__1IOR7"};